import Vue from 'vue';
import Swiper, { Navigation } from 'swiper';
import gsap from 'gsap/all';


Swiper.use([Navigation]);

Vue.component('testimonial-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            swiperSlider: null,
            nextTitle: '',
            previousTitle: '',
            initialSlide: 0,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        EventBus.$on('initTestimonials', (slide) => {
            let index = parseInt(slide, 10);
            this.initialSlide = index - 1;
            gsap.delayedCall(1, ()=> {
            this.init();
            });
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        init() {
            this.initSwiper();
        },

        initSwiper() {
            console.log(this.initialSlide);
            this.swiperSlider = new Swiper(this.$refs.testimonialslider, {
                modules: [Navigation],
                direction: 'horizontal',
                loop: true,
                slidesPerView: 1,
                centeredSlides: true,
                spaceBetween: 0,
                initialSlide: this.initialSlide, 
                navigation: {
                    nextEl: ".testimonial__next",
                    prevEl: ".testimonial__previous",
                },
                on: {
                    afterInit: () => {
                        gsap.to('.testimonials-wrapper', { autoAlpha: '1' });
                    },
                    slideChangeTransitionEnd: ()=> {
                        let nextElement = document.querySelector('.testimonial-slide.swiper-slide-next');
                        let previousElement = document.querySelector('.testimonial-slide.swiper-slide-prev');
                        let nextTitle = nextElement.getAttribute('data-slide-client');
                        let previousTitle = previousElement.getAttribute('data-slide-client');
                        this.nextTitle = nextTitle;
                        this.previousTitle = previousTitle;
                    },
                },
            });
        },

        destroySwiper() {
            if (!this.swiperSlider) {
                return;
            }

            this.swiperSlider.destroy();
            this.swiperSlider = null;
        },
    }
});
